import library from './library.module'
export default library
